import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=2c872504&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"
import style0 from "./foot.vue?vue&type=style&index=0&id=2c872504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c872504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c872504')) {
      api.createRecord('2c872504', component.options)
    } else {
      api.reload('2c872504', component.options)
    }
    module.hot.accept("./foot.vue?vue&type=template&id=2c872504&scoped=true", function () {
      api.rerender('2c872504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/foot.vue"
export default component.exports